export const DEFAULT_UNIT_DELIVERY_TIME = "Dias úteis";

export const UNIT_DELIVERY_TIME_MAX_LENGTH = 15;

export type UnitDeliveryTimeLabels = {
  labelForForm: string;
  labelForMessage: string;
};

export function resolveUnitDeliveryTime(unit: string | null | undefined): string {
  const trimmed = unit?.trim();
  return trimmed || DEFAULT_UNIT_DELIVERY_TIME;
}

export function resolveUnitDeliveryTimeLabels(
  unit: string | null | undefined
): UnitDeliveryTimeLabels {
  const resolved = resolveUnitDeliveryTime(unit);

  return {
    labelForForm: resolved,
    labelForMessage: resolved.toLowerCase(),
  };
}

export function normalizeUnitDeliveryTimeForApi(unit: string | null | undefined): string | null {
  const trimmed = unit?.trim();
  return trimmed || null;
}

export function buildRegionalDeliveryTimeLabel(labelForForm: string): string {
  return `Prazo de Entrega (${labelForForm})`;
}

export function buildLeadTimeLabel(labelForMessage: string): string {
  return `Prazo de preparação e manuseio (${labelForMessage})`;
}

const INPUT_LABEL_FONT = '400 0.75rem "Roboto","Helvetica","Arial",sans-serif';

export function measureTextWidth(text: string, font: string): number {
  if (typeof document === "undefined") return text.length * 8;

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return text.length * 8;

  context.font = font;
  return Math.ceil(context.measureText(text).width);
}

export function getFieldWidthFromLabel(label: string, extraPx = 4): number {
  return measureTextWidth(label, INPUT_LABEL_FONT) + extraPx;
}
